export const PLUGIN_PROVIDERS = {
  bullhorn: {
    label: 'BullHorn',
    value: 'bullhorn'
  },
  calendly: {
    label: 'Calendly',
    value: 'calendly'
  },
  chilipiper: {
    label: 'Chili Piper',
    value: 'chilipiper'
  },
  clearbit: {
    label: 'Clearbit',
    value: 'clearbit'
  },
  customerio: {
    label: 'Customer.io',
    value: 'customerio'
  },
  drift: {
    label: 'Drift',
    value: 'drift'
  },
  dynamics: {
    label: 'Dynamics',
    value: 'dynamics'
  },
  eloqua: {
    label: 'Eloqua',
    value: 'eloqua'
  },
  hubspot: {
    label: 'Hubspot',
    value: 'hubspot'
  },
  marketo: {
    label: 'Marketo',
    value: 'marketo'
  },
  netsuite: {
    label: 'Netsuite',
    value: 'netsuite'
  },
  onetrust: {
    label: 'OneTrust',
    value: 'onetrust'
  },
  outreach: {
    label: 'Outreach',
    value: 'outreach'
  },
  pardot: {
    label: 'Pardot',
    value: 'pardot'
  },
  rollworks: {
    label: 'RollWorks',
    value: 'rollworks'
  },
  salesforce: {
    label: 'Salesforce',
    value: 'salesforce'
  },
  securityScorecard: {
    label: 'Security Scorecard',
    value: 'securityscorecard'
  },
  surefire: {
    label: 'Surefire',
    value: 'surefire'
  },
  totalExpert: {
    label: 'TotalExpert',
    value: 'totalexpert'
  },
  twitter: {
    label: 'X',
    value: 'twitter'
  },
  custom: {
    label: 'label.CUSTOM',
    value: 'custom'
  }
};

export const PLUGIN_PROVIDERS_ARRAY = Object.values(PLUGIN_PROVIDERS);

export const DEFAULT_PLUGIN_CONFIGS = {
  chilipiper: [
    {
      name: 'yourdomain',
      value: '',
      hidden: false
    },
    {
      name: 'router',
      value: '',
      hidden: false
    }
  ],
  clearbit: [
    {
      name: 'api_key',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  customerio: [
    {
      name: 'apikey',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  eloqua: [
    {
      name: 'api_username',
      value: '',
      hidden: false
    },
    {
      name: 'api_password',
      value: '',
      hidden: true
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  hubspot: [
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  marketo: [
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    },
    {
      name: 'endpoint',
      value: '',
      hidden: false
    },
    {
      name: 'identity',
      value: '',
      hidden: false
    },
    {
      name: 'clientid',
      value: '',
      hidden: false
    },
    {
      name: 'clientsecret',
      value: '',
      hidden: false
    }
  ],
  netsuite: [
    {
      name: 'account',
      value: '',
      hidden: false
    },
    {
      name: 'consumer_secret',
      value: '',
      hidden: true
    },
    {
      name: 'consumer_key',
      value: '',
      hidden: false
    },
    {
      name: 'token',
      value: '',
      hidden: false
    },
    {
      name: 'token_secret',
      value: '',
      hidden: true
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    },
    {
      name: 'field_id',
      value: '',
      hidden: false
    }
  ],
  onetrust: [
    {
      name: 'client_id',
      value: '',
      hidden: false
    },
    {
      name: 'client_secret',
      value: '',
      hidden: true
    },
    {
      name: 'instance',
      value: '',
      hidden: false
    }
  ],
  outreach: [
    {
      name: 'adsfieldname',
      value: '',
      hidden: false
    },
    {
      name: 'instanceid',
      value: '',
      hidden: false
    },
    {
      name: 'tagsfieldname',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  pardot: [
    {
      name: 'email',
      value: '',
      hidden: false
    },
    {
      name: 'password',
      value: '',
      hidden: true
    },
    {
      name: 'userkey',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    }
  ],
  rollworks: [
    {
      name: 'advertisable_eid',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    },
    {
      name: 'version',
      value: '',
      hidden: false
    }
  ],
  salesforce: [
    {
      name: 'adminemail',
      value: '',
      hidden: false
    },
    {
      name: 'instanceUrl',
      value: '',
      hidden: false
    },
    {
      name: 'fields',
      value: '',
      hidden: false
    },
    {
      name: 'ignoresgenfields',
      value: '',
      hidden: false
    },
    {
      name: 'testrecipient',
      value: '',
      hidden: false
    },
    {
      name: 'entity',
      value: '',
      hidden: false
    }
  ]
};

export const PLUGIN_BADGES = {
  bullhorn: {
    label: 'BullHorn',
    color: '#f36c22',
    textColor: '#ffffff'
  },
  calendly: {
    label: 'Calendly',
    color: '#006bff',
    textColor: '#ffffff'
  },
  chilipiper: {
    label: 'Chili Piper',
    color: '#ff5721',
    textColor: '#ffffff'
  },
  clearbit: {
    label: 'Clearbit',
    color: '#4b8ecc',
    textColor: '#ffffff'
  },
  customerio: {
    label: 'Customer.io',
    color: '#000000',
    textColor: '#ffffff'
  },
  drift: {
    label: 'Drift',
    color: '#000000',
    textColor: '#ffffff'
  },
  dynamics: {
    label: 'Dynamics',
    color: '#004fc4',
    textColor: '#ffffff'
  },
  eloqua: {
    label: 'Eloqua',
    color: '#e51635',
    textColor: '#ffffff'
  },
  hubspot: {
    label: 'Hubspot',
    color: '#ff7a59',
    textColor: '#ffffff'
  },
  marketo: {
    label: 'Marketo',
    color: '#5c4c9f',
    textColor: '#ffffff'
  },
  netsuite: {
    label: 'Netsuite',
    color: '#00467f',
    textColor: '#ffffff'
  },
  onetrust: {
    label: 'OneTrust',
    color: '#55a05e',
    textColor: '#ffffff'
  },
  outreach: {
    label: 'Outreach',
    color: '#5952ff',
    textColor: '#ffffff'
  },
  pardot: {
    label: 'Pardot',
    color: '#139cd8',
    textColor: '#ffffff'
  },
  rollworks: {
    label: 'RollWorks',
    color: '#4aba7a',
    textColor: '#ffffff'
  },
  salesforce: {
    label: 'Salesforce',
    color: '#139cd8',
    textColor: '#ffffff'
  },
  securityscorecard: {
    label: 'SecurityScorecard',
    color: '#00184a',
    textColor: '#ffffff'
  },
  surefire: {
    label: 'Surefire',
    color: '#bf3432',
    textColor: '#ffffff'
  },
  totalexpert: {
    label: 'TotalExpert',
    color: '#00263a',
    textColor: '#ffffff'
  },
  twitter: {
    label: 'X',
    color: '#000000',
    textColor: '#ffffff'
  },
  custom: {
    label: 'label.CUSTOM',
    color: '#0066eb',
    textColor: '#ffffff'
  }
};
